import { render, staticRenderFns } from "./KbDataPage.vue?vue&type=template&id=96f071f6&scoped=true"
import script from "./KbDataPage.vue?vue&type=script&lang=js"
export * from "./KbDataPage.vue?vue&type=script&lang=js"
import style0 from "./KbDataPage.vue?vue&type=style&index=0&id=96f071f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f071f6",
  null
  
)

export default component.exports